// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--cs6wc"};